<template>
    <div class="guide-widget-wrapper">
        <div class="widget-operator">
            <span class="op">
                <i class="delete" @click="deleteWidget"></i>
            </span>
            <span class="op">
                <i class="transfer" @mousedown="transPosition"></i>
            </span>
        </div>
        <component :is="widget.wtType" :data="widget" @updateContent="updateContent" />
    </div>
</template>

<script>
import GuidePicture from "./guideWidgets/GuidePicture";
import GuideText from "./guideWidgets/GuideText";
import i18n from "@/i18n";

export default {
    name: "GuideWidgetWrapper",
    components: {
        GuideText,
        GuidePicture
    },
    props: ["widget"],
    methods: {
        deleteWidget() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.answer.deleteWidgetTip"),
                    confirm: () => {
                        let delWidget = Object.assign({}, this.widget, {
                            updateState: "delete"
                        });

                        this.$emit("deleteContent", delWidget);
                    }
                }
            });
        },
        transPosition(event) {
            this.zhiji.dragStart(event, "guide-widget-wrapper", "v", newIdx => {
                this.$emit("tranferContent", {
                    newIdx: newIdx,
                    uId: this.widget.uId,
                    updateState: "transfer"
                });
            });
        },
        updateContent(data) {
            this.$emit("updateContent", data);
        }
    }
};
</script>

<style lang="less" scoped>
.guide-widget-wrapper {
    padding-top: 24px;
    display: flex;
    flex-direction: row;

    .widget-operator {
        display: inline-flex;
        flex-direction: column;
        margin-right: 10px;

        .op {
            margin-bottom: 8px;
            cursor: pointer;
            display: inline-flex;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
            background: #fff;
        }

        .delete,
        .transfer {
            position: relative;
            display: inline-block;
            width: 16px;
            height: 18px;
            margin: 0 5px 0 5px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
        }

        .transfer {
            width: 13px;
            background-position: -113px 0;

            &:hover {
                background-position: -113px -22px;
            }
        }

        .delete {
            background-position: -96px 0;

            &:hover {
                background-position: -96px -22px;
            }
        }
    }

    &.moving {
        user-select: none;
    }
}
</style>
